import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "accountDetails"
const AccountDetailsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.875 22.875H13.875V21.375H22.875zM10.5 13.125C11.174 13.125 11.798 13.168 12.375 13.245V14.762C11.812 14.674 11.19 14.625 10.5 14.625 6.508 14.625 4.756 16.24 3.911 17.647 3.607 18.154 3.404 18.667 3.267 19.125H12.375V20.625H1.5S1.5 13.125 10.5 13.125M22.875 19.5H13.875V18H22.875zM22.875 16.125H13.875V14.625H22.875z" />
          <path
            fillRule="evenodd"
            d="M10.875 1.5C13.567 1.5 15.75 3.683 15.75 6.375S13.567 11.25 10.875 11.25 6 9.067 6 6.375 8.183 1.5 10.875 1.5M10.875 3C9.011 3 7.5 4.511 7.5 6.375S9.011 9.75 10.875 9.75 14.25 8.239 14.25 6.375 12.739 3 10.875 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default AccountDetailsIcon
